import { NOT_FOUND_ICON_PROPS, NOT_FOUND_RESOURCE_ICONS } from "./notFound.constants";

const NotFoundResourceIcon = ({ type }) => {
    const Icon = NOT_FOUND_RESOURCE_ICONS[type];
    if (!Icon) return null;
    return <Icon style={NOT_FOUND_ICON_PROPS} />;
};

export default NotFoundResourceIcon;
